import { FallbackProps } from "react-error-boundary"

export default function BSOD({ error }: FallbackProps) {
  return <span>Error happened {error.message}</span>
}
